import React from "react";
import { ArrowDown } from "lucide-react";
import Reveal from "@/components/Reveal";
import Newsletter from "@/components/Newsletter";
import { DECISION_FLOW } from "@/data/content";
import { useWaitlist } from "@/context/WaitlistContext";

export default function AIPlatform() {
  const { openWaitlist } = useWaitlist();
  return (
    <div data-testid="ai-platform-page" className="pt-32">
      <section className="relative overflow-hidden py-12 md:py-20">
        <div className="mesh-bg">
          <div className="mesh-blob" style={{ width: 480, height: 480, background: "#4B2E5A", opacity: 0.12, top: -120, left: -80 }} />
          <div className="mesh-blob" style={{ width: 400, height: 400, background: "#F28C82", bottom: -80, right: -40 }} />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center md:px-12">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F28C82]">Naari AI Platform</p>
            <h1 className="mt-6 font-heading text-4xl font-light tracking-tighter text-[#4B2E5A] md:text-6xl">
              One intelligence across every decision
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-[#4B2E5A]/70">
              The Naari AI Platform is the shared brain behind every product — combining your preferences, context and habits into a single decision engine.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-16">
        <div className="mx-auto max-w-2xl px-6 md:px-12">
          <Reveal className="glass rounded-[24px] p-8 md:p-10">
            {DECISION_FLOW.map((step, i) => (
              <div key={step}>
                <div className="flex items-center gap-3 rounded-2xl bg-white/60 px-5 py-3.5">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#4B2E5A] text-xs font-medium text-white">{i + 1}</span>
                  <span className="font-medium text-[#4B2E5A]">{step}</span>
                </div>
                <div className="flex justify-center py-1.5"><ArrowDown className="h-4 w-4 text-[#4B2E5A]/30" /></div>
              </div>
            ))}
            <div className="rounded-2xl bg-[#4B2E5A] px-5 py-4 text-center">
              <span className="font-heading text-lg font-medium text-[#FCFAF7]">Today's Best Decision</span>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="mt-10 text-center">
            <button data-testid="platform-early-access-btn" onClick={() => openWaitlist("Naari AI")} className="rounded-full bg-[#4B2E5A] px-8 py-4 text-sm font-medium text-[#FCFAF7] hover:bg-[#4B2E5A]/90">
              Join Early Access
            </button>
          </Reveal>
        </div>
      </section>
      <Newsletter />
    </div>
  );
}
